import { TextLargeParagraph } from '@carboncopyco/ui';
import { getTimezoneName } from '@carboncopyco/utils';
import { useState } from 'react';
import type { CsvParams } from '../../../Dashboard/SessionBreakdownComponents/types';
import { PresentationsSessionsBreakdown } from '../../DemoPage/ActivitiesTab/SessionsBreakdownCard/PresentationsSessionsBreakdown';
import { DownloadCsvButton } from '../../DownloadCsv';
import { TitleCard } from '../../InfoPageCards/TitleCard';
import { useOverlayPageProps } from '../OverlayPageContext';

export const SessionsBreakdownCard = () => {
  const { organizationId, demoId, workspaceId } = useOverlayPageProps();
  const [csvParams, setCsvParams] = useState<CsvParams>({
    params: {
      organizationId,
      resourceTypes: ['managed_presentation'],
      timezone: getTimezoneName(),
    },
    isDisabled: false,
  });

  return (
    <TitleCard
      radius
      border="ds-regular"
      header={
        <div className="h-ds-15 flex px-6 items-center justify-between">
          <TextLargeParagraph
            label="Session breakdown"
            color="text-ds-natural-600"
          />
          <div className="flex gap-4">
            <DownloadCsvButton
              params={csvParams.params}
              disabled={csvParams.isDisabled}
              location="demo_overlay_info_page"
            />
          </div>
        </div>
      }
    >
      <PresentationsSessionsBreakdown
        demoId={demoId}
        workspaceId={workspaceId}
        organizationId={organizationId}
        setCsvParams={setCsvParams}
        isOverlay
      />
    </TitleCard>
  );
};
